"use client";
import { Skeleton } from "@ui/components/data-display/skeleton/Skeleton";
import { Box } from "@ui/components/layout/box/Box";
import { Flex } from "@ui/components/layout/flex/Flex";

export const MyAccountSkeleton = () => {
    return (
        <Box pt={4} bg="gray.100">
            <Flex px={[3, 3, 6]} mx={[3, 3, 6]} bg="white" py={8} direction="column" gap={12}>
                <Skeleton w={[200, 500]} h={70} />
                <Flex gap={0.2}>
                    <Skeleton w={100} h={50} />
                    <Skeleton w={100} h={50} />
                    <Skeleton w={100} h={50} />
                    <Skeleton w={100} h={50} />
                </Flex>
                <Skeleton w="full" h={500} />
            </Flex>
        </Box>
    );
};
